import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/UserAuth';

function Login() {
  const navigate = useNavigate();
  const { loginUserAuth, googleSignIn } = useAuth();
  const [loginUser, setLoginUser] = useState({ email: '', password: '' });

  const _onChange = (e) => {
    setLoginUser((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
  };

  /**
   * ! login
   */
  const handleLogin = (e) => {
    e.preventDefault();
    if (!loginUser.email && !loginUser.password) return;

    loginUserAuth(loginUser.email, loginUser.password);

    navigate('/');
  };

  /**
   * ! GoogleSignIn
   */
  const handleGoogleSignIn = async (e) => {
    e.preventDefault();

    await googleSignIn();

    navigate('/');
  };

  ////////////////////////////////////////////////////////////////////////////
  return (
    <div className='container col-xl-10 col-xxl-8 px-4 py-5'>
      <div className='row align-items-center g-lg-5 py-5'>
        <div className='col-lg-7 text-center text-lg-start'>
          <h1 className='display-4 fw-bold lh-1 mb-3'>
            Firebase V9 Perfomming CRUD Operation + Auth + file/imgae uploading
          </h1>
          <p className='col-lg-10 fs-4'>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati accusamus earum mollitia cumque
            architecto recusandae natus tenetur sed corporis, iusto tempore illo autem et quam placeat ullam consequatur
            magni aperiam?
          </p>
        </div>
        <div className='col-md-10 mx-auto col-lg-5'>
          <form className='p-4 p-md-5 border rounded-3 bg-light'>
            <div className='form-floating mb-3'>
              <input
                type='email'
                className='form-control'
                id='floatingInput'
                placeholder='name@example.com'
                onChange={_onChange}
                name='email'
                value={loginUser.email}
                required
              />
              <label htmlFor='floatingInput'>Email address</label>
            </div>
            <div className='form-floating mb-3'>
              <input
                type='password'
                className='form-control'
                id='floatingPassword'
                placeholder='Password'
                autoComplete=''
                onChange={_onChange}
                name='password'
                value={loginUser.password}
                required
              />
              <label htmlFor='floatingPassword'>Password</label>
            </div>

            <button className='w-100 btn btn-lg btn-primary' type='submit' onClick={handleLogin}>
              Login
            </button>
            <p className='mt-3'>
              if you do't an account please <Link to='/signup'>Signup</Link>
            </p>
            <hr className='my-4' />
            <h2 className='fs-5 fw-bold mb-3'>Or use a third-party</h2>
            <button
              className='w-100 py-2 mb-2 btn btn-outline-dark rounded-4'
              type='submit'
              onClick={handleGoogleSignIn}
            >
              <i className='bi bi-google me-3'></i>
              Sign up with Google
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
